import { useContext } from "react";
import { VenuePlanControlContext } from "../reactcontext/venue-plan-control-context";

export function useVenuePlanControl() {
    const ctx = useContext(VenuePlanControlContext);
    return ctx.remoteControl;
}


